import { get } from 'lodash-es';
import * as z from 'zod';
import * as ba from './base';
import { SCRIPT_SCHEMA } from '../scripting';
import { assertComponentContext } from '../helpers';

export interface ResourceActionArgs {
  method: 'patch' | 'delete';
  target: any;
  data: any;
}

export class ResourceAction extends ba.Action<ResourceActionArgs, any> {
  static get manifest() {
    return {
      name: 'resource',
      schema: z.object({
        method: z.union([z.literal('patch'), z.literal('delete')]),
        target: z.union([SCRIPT_SCHEMA(), z.record(z.string(),z.any())]),
        data: z.union([SCRIPT_SCHEMA(), z.record(z.string(),z.any())]),
      }),
    };
  }

  async handle(event: ba.ActionEvent, args: ResourceActionArgs) {
    assertComponentContext(event.component);
    const conn = event.component.$app.connections.default;
    const target = args.target;
    const url = get(target, 'self', get(target, 'links.self'));
    if (!url) {
      throw new Error(
        'Cannot create request: missing "self" value on data object.',
      );
    }
    const etag = get(target, '$etag', get(target, 'etag'));
    const headers: Dictionary<string> = {};
    if (etag) {
      headers['If-Match'] = etag;
    }

    const response = await conn.ajax({
      url,
      method: args.method,
      headers,
      data: args.data,
    });
    if (args.method === 'delete') {
      event.component.$app.events?.emit('resource:deleted', {
        id: get(target, 'id'),
      });
    }
    await this.dispatch('success', response);
    return response;
  }
}
